import blackTshirt from '../assets/img/market/tshirtBlack.jpg';
import redTshirt from '../assets/img/market/tshirtRed.jpg';
import colorLeafSkirt from '../assets/img/market/skirtColorLeaf.jpg';
import blueSkirt from '../assets/img/market/skirtBlue.jpg';
import redSkirt from '../assets/img/market/skirtRed.jpg';
import blackSkirt from '../assets/img/market/skirtBlack.jpg';

export const MARKETITEMS = [
    {
        itemNumber: 1,
        name: 'T-Shirt',
        colors: ['#000000','#A52A2A', '#7FFF00', '#8B008B'],
        sizes: ['Sm', 'Md', 'Lg', 'xL'],
        description: 'Black Cotton T-Shirt for the hot summer months.',
        price: 15.00,
        itemImage: blackTshirt
    },
    {
        itemNumber: 2,
        name: 'T-Shirt',
        colors: ['#000000','#A52A2A', '#7FFF00', '#8B008B'],
        sizes: ['Sm', 'Md', 'Lg', 'xL'],
        description: 'Red Cotton T-Shirt for the hot summer months.',
        price: 15.00,
        itemImage: redTshirt
    },
    {
        itemNumber: 3,
        name: 'Skirt',
        colors: ['#000000','#A52A2A', '#7FFF00', '#8B008B'],
        sizes: ['Sm', 'Md', 'Lg', 'xL'],
        description: 'Skin Tight, Over the knee mustard yellow skirt.',
        price: 30.00,
        itemImage: colorLeafSkirt
    },
    {
        itemNumber: 4,
        name: 'Skirt',
        colors: ['#000000','#A52A2A', '#7FFF00', '#8B008B'],
        sizes: ['Sm', 'Md', 'Lg', 'xL'],
        description: 'Skin Tight, Over the knee blue skirt.',
        price: 30.00,
        itemImage: blueSkirt
    },
    {
        itemNumber: 5,
        name: 'Skirt',
        colors: ['#000000','#A52A2A', '#7FFF00', '#8B008B'],
        sizes: ['Sm', 'Md', 'Lg', 'xL'],
        description: 'Loose skirt, over the knee red skirt.',
        price: 45.00,
        itemImage: redSkirt
    },
    {
        itemNumber: 6,
        name: 'Skirt',
        colors: ['#000000','#A52A2A', '#7FFF00', '#8B008B'],
        sizes: ['Sm', 'Md', 'Lg', 'xL'],
        description: 'Loose skirt, Over the knee black skirt.',
        price: 45.00,
        itemImage: blackSkirt
    }
];